import request from './request';

export async function getOpinions(id, params) {
  return await request('get', `/apiv2/group-opinions/${id}`, params);
}

export function createOpinion(id, params) {
  return request('post', `/apiv2/group-opinions/${id}/create`, params);
}

export function deleteGroupOpinion(id, data) {
  return request('post', `/apiv2/group-opinions/${id}/delete`, data);
}

export function editGroupOpinion(id, params) {
  return request('put', `/apiv2/group-opinions/${id}/update`, params);
}
